import { WORKFLOW_FIELDS } from '../fragments'

export default `
  ${WORKFLOW_FIELDS}
  query getWorkflow($workflowId: String!, $projectId: String!) {
    getWorkflow(workflowId: $workflowId, projectId: $projectId) {
      ...WorkflowFields
    }
  }
`
